/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Usage_DescriptionInputs */

const en_cookies_usage_description = /** @type {(inputs: Cookies_Usage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies keep you signed in and, with your permission, help us understand how the app is used. You control every category except the strictly necessary one.`)
};

const pl_cookies_usage_description = /** @type {(inputs: Cookies_Usage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pliki cookie utrzymują Cię zalogowanym i, z Twoją zgodą, pomagają nam zrozumieć, jak korzysta się z aplikacji. Panujesz nad każdą kategorią poza bezwzględnie niezbędną.`)
};

/**
* | output |
* | --- |
* | "Cookies keep you signed in and, with your permission, help us understand how the app is used. You control every category except the strictly necessary one." |
*
* @param {Cookies_Usage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_usage_description = /** @type {((inputs?: Cookies_Usage_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Usage_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_usage_description(inputs)
	return en_cookies_usage_description(inputs)
});